import Phaser from 'phaser';
import { gsap } from 'gsap';

import gameConfig from '../../../config/game';
import UrlUtils from '../../../../../common/utils/url';


export default class TimeLimit{

    constructor(){
        this.scene =  window.GAME_REF.scene;
        this.emitter = new Phaser.Events.EventEmitter();

        this.EVENT_COMPLETE = 'time_complete';

        this.tween = null;
        this.container = null;
        this.progressbar = null;

        this.pause = this.pause.bind(this);
        this.resume = this.resume.bind(this);

        this.query = UrlUtils.getQuery();

        this._init();
    }


    render(){

        this.scene.tweens.add({
            targets: this.container,
            alpha: 1,
            duration: 300,
            ease: 'Cubic.easeOut'
        });
    }


    start(){
        const time = this.query.time ? this.query.time : gameConfig.time;
        const progress = { w: 510 };

        this.tween = gsap.to(progress, {
            duration: time, 
            w: 12, 
            ease:'linear', 
            onUpdate:()=>{
                this.progressbar.clear();
                this.progressbar.fillStyle(0xFFFFFF);
                this.progressbar.fillRoundedRect(0, 0, progress.w, 12, 6);
            },
            onComplete:()=>{
                window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this.pause);
                window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this.resume);
                this.progressbar.clear();
                this.emitter.emit(this.EVENT_COMPLETE);
            }
        });

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this.pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this.resume);
    }


    _init(){
        this._create();
    }


    _create(){
        this.container = this.scene.add.container(17, 727);
        this.container.alpha = 0;

        // バーの背景を描画
        const bgBar = this.scene.add.graphics({fillStyle: {color: 0x2B2B2B}});
        bgBar.fillRoundedRect(0, 0, 510, 12, 6);
        this.container.add(bgBar);

        this.progressbar = this.scene.add.graphics({fillStyle: {color: 0xFFFFFF}});
        this.progressbar.fillRoundedRect(0, 0, 510, 12, 6);
        this.container.add(this.progressbar);
    }


    pause(){
        this.tween.pause();
    }

    resume(){
        this.tween.resume();
    }
}